<template>
  <div :class="`${infoTypeScheme[props.type]} flex items-center justify-center gap-8 p-8 rounded-8`">
    <se-icon :name="props.icon" :size="16" />
    <p class="text-b-xs text-center">
      {{ props.infoText }}
    </p>
  </div>
</template>

<script setup lang="ts">
import SeIcon from '../../../../shared/ui-kit/icon/Icon.vue';

const props = withDefaults(defineProps<{
  icon: string,
  infoText: string,
  type: 'success' | 'warning' | 'error',
}>(), {
  icon: 'lock',
  infoText: '',
  type: 'success',
});

const infoTypeScheme = {
  error: 'bg-error-10 text-error-100',
  warning: 'bg-warning-10 text-warning-100',
  success: 'bg-success-10 text-success-100',
};
</script>

<script lang="ts">
export default {
  name: 'SeChatBoxInfo',
};
</script>
